import $ from 'jquery';
import { getClosestByEventPath } from './utils.js';

const getClosestElement = function($element, classname) {
    let $_element = $element.parentElement;

    while($_element) {
        if($_element.classList.contains(classname)) {
            return $_element;
        }

        $_element = $_element.parentElement;
    }

    return null;
}

export default function() {
    const $lists  = document.querySelectorAll('.js-product-list');

    $lists.forEach(($list) => {

        $list.addEventListener('click', function(e) {
            let $pane = getClosestByEventPath(e, 'js-product-list-item-pane');

            if($pane) {
                let isLoading = $pane.classList.contains('_is-loading');
                let $item = getClosestElement($pane, 'js-product-list-item');
                const url = $pane.getAttribute('data-url');

                if(isLoading) {
                    return;
                }

                $pane.classList.add('_is-loading');

                if(url) {
                    fetch(url)
                        .then(response => {
                            return response.json();
                        })
                        .then(data => {
                            if(data.products) {
                                const $tableWrapper = $pane.parentElement.querySelector('.js-product-list-item-table-wrapper');

                                if($tableWrapper) {
                                    $tableWrapper.innerHTML = data.products;
                                }
                            }

                            $pane.classList.remove('_is-loading');
                            $pane.removeAttribute('data-url');
                            $item.classList.toggle('_is-expanded');
                        })
                        .catch(() => {
                            $pane.classList.remove('_is-loading');
                        });
                }
                else {
                    $pane.classList.remove('_is-loading');
                    $item.classList.toggle('_is-expanded');
                }
            }
        });
    });
}
